import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";

const maxRetries = 2;

const baseQuery = retry(
	fetchBaseQuery({
		baseUrl: process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE,
	}),
	{ maxRetries }
);

export const reportAPI = createApi({
	reducerPath: "reportAPI",
	baseQuery,
	keepUnusedDataFor: 0,
	tagTypes: ["tagGetReports"],
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		//* *********************************************************** */
		//* GET REPORT OFFSETS */
		getLiftReport: builder.query({
			query: (body: any) => ({
				url: `/lift-records/?page=${body.page}&limit=${
					body.limit
				}&sort_direction=asc&${body.searchAndFilterString || ""}`,
				headers: { authorization: body.token },
			}),
			providesTags: ["tagGetReports"],
		}),
		//* *********************************************************** */
		//* GET REPORT BENEFICIAL */
		getBeneficialReport: builder.query({
			query: (body: any) => ({
				url: `/lift-records/beneficial-usage?${
					body.searchAndFilterString || ""
				}&sort_direction=asc`,
				headers: { authorization: body.token },
			}),
			providesTags: ["tagGetReports"],
		}),
		//* *********************************************************** */
		//* GET REPORT PERFORMANCE */
		getPerformanceReport: builder.query({
			query: (body: any) => ({
				url: `/lift-records/performance?${
					body.searchAndFilterString || ""
				}&sort_direction=asc`,
				headers: { authorization: body.token },
			}),
			providesTags: ["tagGetReports"],
		}),
		//* *********************************************************** */
		//* GET REPORT OUT OF SERVICE */
		getOutOfServiceReport: builder.query({
			query: (body: any) => ({
				url: `/lift-records/out-of-service?${
					body.searchAndFilterString || ""
				}&sort_direction=asc`,
				headers: { authorization: body.token },
			}),
			providesTags: ["tagGetReports"],
		}),
		//* *********************************************************** */
	}),
});

export const {
	useLazyGetLiftReportQuery,
	useLazyGetBeneficialReportQuery,
	useLazyGetPerformanceReportQuery,
	useLazyGetOutOfServiceReportQuery,
} = reportAPI;
